import React from 'react';
import { sanitizePortalHtml } from '../../utils/sanitizePortalHtml';

const PortalHtml = ({ html, className, style }) => {
  const clean = sanitizePortalHtml(html);
  if (!clean) return null;
  return (
    <div
      className={className}
      style={{ lineHeight: 1.65, ...style }}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
};

export default PortalHtml;
